module.exports = __webpack_public_path__ + "static/media/photography06.896e86eb.png";